
import * as React from 'react';
import * as showdown from 'showdown';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faDownload, } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
library.add(faDownload)

import { download, IResponseResult } from '../logic/requester';
import { bufferToString } from '../logic/util';
import './style.css';

const Showdown = new showdown.Converter({ tables: true });

function renderResponse(result: IResponseResult) {
  const { extension, filename } = result;
  let body = bufferToString(result.body!);
  if (!body) return <p>No response</p>;
  let render: JSX.Element;
  switch (extension) {
    case 'md':
      body = Showdown.makeHtml(body);
    case 'html':
      render = <div className="result" dangerouslySetInnerHTML={{ __html: body }} />;
      break;
    case 'txt':
      render = <pre><code>{body}</code></pre>;
      break;
    default:
      render = <p className="error">A file with extension {extension} can't be previewed in the browser</p>;
  }
  const onClick = () => download(result);
  return <div>
    <p>
      <b>{filename || 'Unnamed'}.{extension}</b> ({Math.floor(body.length / 1024)}kb)
      <button className="download info" onClick={onClick}><FontAwesomeIcon icon="download"/> Download</button>
    </p>
    {render}
  </div>;
}

interface IResultProps {
  result: IResponseResult;
  hide?: () => void;
}

class Result extends React.Component<IResultProps> {
  constructor(props: any, context: any) {
    super(props, context);
  }
  public render() {
    const res = this.props.result;
    return (
      <div className="Result">
        {this.props.hide && <button className="close" onClick={this.props.hide}><FontAwesomeIcon icon="minus"/></button>}
        <h3>{res.errorMessage ? 'Error' : 'Result'}</h3>
        {res && <div className="content">
          {res.errorMessage && <pre className="error">{res.errorMessage}</pre>}
          {renderResponse(res)}
        </div>}
      </div>
    );
  }
}

export default Result;



// WEBPACK FOOTER //
// ./src/Result/index.tsx